<template>
  <UiPageTitle title="Настройки аккаунта" hide-arrow />
</template>

<script>
import UiPageTitle from '@/components/UiPageTitle.vue'

export default {
  components: { UiPageTitle },
}
</script>
